import { brandColors, semanticColors } from '../theme/tokens/colors';
import { getConnectorStatusDescription } from './ChargePointHelper';

export const connectorStatusTone = {
    available: 'available',
    busy: 'busy',
    unavailable: 'unavailable',
};

const connectorStatuses = {
    available: 'Available',
    preparing: 'Preparing',
    charging: 'Charging',
    suspendedEV: 'SuspendedEV',
    suspendedEVSE: 'SuspendedEVSE',
    finishing: 'Finishing',
};

const normalize = (value) => (value || '').toString().trim();

export const getConnectorStatusTone = (chargePointStatus, connectorStatus) => {
    const normalizedChargePointStatus = normalize(chargePointStatus);
    const normalizedConnectorStatus = normalize(connectorStatus);

    if (normalizedChargePointStatus !== 'Connected') {
        return connectorStatusTone.unavailable;
    }

    if (normalizedConnectorStatus === connectorStatuses.available || normalizedConnectorStatus === connectorStatuses.preparing) {
        return connectorStatusTone.available;
    }

    if (
        normalizedConnectorStatus === connectorStatuses.charging ||
        normalizedConnectorStatus === connectorStatuses.suspendedEV ||
        normalizedConnectorStatus === connectorStatuses.suspendedEVSE ||
        normalizedConnectorStatus === connectorStatuses.finishing
    ) {
        return connectorStatusTone.busy;
    }

    return connectorStatusTone.unavailable;
};

export const getConnectorStatusColor = (chargePointStatus, connectorStatus) => {
    const tone = getConnectorStatusTone(chargePointStatus, connectorStatus);

    switch (tone) {
        case connectorStatusTone.available:
            return brandColors.green;
        case connectorStatusTone.busy:
            return brandColors.yellow;
        default:
            return brandColors.red;
    }
};

export const getConnectorStatusTitlePresentation = (translatedData, chargePointStatus, connectorStatus) => {
    const normalizedConnectorStatus = normalize(connectorStatus);
    const getLocalizedTitle = (translationPath, fallback) => {
        const translationValue = translatedData && translatedData.general
            ? translatedData.general.connectorStatusTitleOverrides?.[translationPath]
            : '';
        return translationValue || fallback;
    };

    if (normalizedConnectorStatus === connectorStatuses.charging) {
        return {
            title: getLocalizedTitle('charging', getConnectorStatusDescription(translatedData, connectorStatuses.charging)),
            color: brandColors.green,
        };
    }

    if (normalizedConnectorStatus === connectorStatuses.suspendedEV || normalizedConnectorStatus === connectorStatuses.suspendedEVSE) {
        return {
            title: getLocalizedTitle('suspended', getConnectorStatusDescription(translatedData, connectorStatus)),
            color: brandColors.yellow,
        };
    }

    if (normalizedConnectorStatus === connectorStatuses.finishing) {
        return {
            title: getLocalizedTitle('finishing', getConnectorStatusDescription(translatedData, connectorStatuses.finishing)),
            color: semanticColors.textPrimary,
        };
    }

    return {
        title: getConnectorStatusDescription(translatedData, connectorStatus),
        color: getConnectorStatusColor(chargePointStatus, connectorStatus),
    };
};
